
import React from "react";
//import Button from "../common/Button";
import styles from "../css/HeroSection.module.css";

const HeroSection = ({ data }: any) => {
  return (
    <section className={styles.heroSection}>
      <div className={styles.heroContent}>
        <h1 className={styles.headline}>{data.headline}</h1>
        <p className={styles.subheadline}>{data.subheadline}</p>
        <div className={styles.ctaContainer}>
          {/*
          <Button {...data.primaryCTA} />
          {data.secondaryCTA && <Button {...data.secondaryCTA} variant="secondary" />}
          */}
        </div>
      </div>
      {data.heroImage && (
        <img 
          src={data.heroImage.src} 
          alt={data.heroImage.alt} 
          className={styles.heroImage}
        />
      )}
      {data.videoBackground && (
        <video 
          src={data.videoBackground.url} 
          poster={data.videoBackground.thumbnailImage.src} 
          autoPlay 
          loop 
          muted 
          className={styles.backgroundVideo}
        />
      )}
      {data.features && (
        <div className={styles.features}>
          {data.features.map((feature: any, index: number) => (
            <div key={index} className={styles.feature}>
              <i className={`${styles.icon} ${feature.icon}`}></i>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default HeroSection;
